import { useState, useMemo, useDebugValue } from "react";
import useResizeObserver from "use-resize-observer/polyfilled";
import debounce from "lodash/debounce";
export function useWidth(wait) {
    const [value, rawSet] = useState();
    const set = useMemo(() => (wait ? debounce(rawSet, wait, { leading: true }) : rawSet), [wait]);
    const { ref } = useResizeObserver({
        onResize: size => {
            set(size.width);
        }
    });
    // useEffect(() => {
    // 	const onWindowResize = () => {
    // 		if (ref.current) rawSet(ref.current.offsetWidth);
    // 	};
    // 	window.addEventListener("resize", onWindowResize);
    // 	return () => window.removeEventListener("resize", onWindowResize);
    // });
    useDebugValue(value);
    return [ref, value];
}
//# sourceMappingURL=useWidth.js.map